import * as React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import { DealerLocation } from "../../../models/features/Integration/DmsSetup";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useDispatch } from "react-redux";
import {
  addShopifySettings,
  useVerifyAccessTokenMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import {
  Alert,
  Button,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import { ErrorMessage, Form, Formik, FormikProps } from "formik";
import * as Yup from "yup";

interface ShopifySettingsProps {
  handleNext: any;
  handleBack: any;
}

export const ShopifyValidationSchema = Yup.object().shape({
  shopUrl: Yup.string()
    .matches(
      /^(https:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com)(?!\/)$/,
      "Please enter a valid URL with this pattern https://XXXXXXXXX.myshopify.com"
    )
    .required("shopUrl is a required field"),
  shopAccessToken: Yup.string().required("shopAccessToken is a required field"),
});

const ShopifySettings: React.FunctionComponent<ShopifySettingsProps> = ({
  handleBack,
  handleNext,
}) => {
  const onVerifyAccessToken = (values: any) => {
    verifyMutation({
      shopAccessToken: values.shopAccessToken,
      shopUrl: values.shopUrl,
    });
  };
  const dispatch = useDispatch();
  const formRef = React.useRef<FormikProps<any>>(null);
  const { shopifyAccessToken, shopifyUrl } = useSelector(
    (state: AppState) => state.dmsReducer
  );
  const [settings, setSetttings] = React.useState({
    isProcessed: shopifyAccessToken ? true : false,
    isValid: shopifyAccessToken ? true : false,
  });
  const [verifyMutation, verifyMutationResult] = useVerifyAccessTokenMutation();

  React.useEffect(() => {
    if (verifyMutationResult.isError) {
      setSetttings({
        ...settings,
        isProcessed: true,
        isValid: false,
      });
    } else {
      if (verifyMutationResult.data?.status == 0) {
        dispatch(
          addShopifySettings({
            token: formRef.current?.values.shopAccessToken,
            url: formRef.current?.values.shopUrl,
          })
        );
        setSetttings({
          ...settings,
          isProcessed: true,
          isValid: true,
        });
      }
    }
  }, [verifyMutationResult]);
  return (
    <>
      <Box height={620}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            size="small"
            variant="contained"
            onClick={handleNext}
            disabled={!(settings.isProcessed && settings.isValid)}
          >
            Next
          </Button>
        </Box>
        <Grid container style={{ justifyContent: "center" }}>
          <Grid item sm={6}>
            <Formik
              initialValues={{
                shopUrl: shopifyUrl ?? "",
                shopAccessToken: shopifyAccessToken ?? "",
              }}
              enableReinitialize
              validationSchema={ShopifyValidationSchema}
              onSubmit={(values) => {
                onVerifyAccessToken(values);
              }}
              innerRef={formRef}
            >
              {({ values, handleChange, handleBlur }) => (
                <>
                  <Form>
                    <FormControl
                      sx={{ m: 3 }}
                      component="fieldset"
                      variant="standard"
                      style={{ alignItems: "center" }}
                    >
                      <FormLabel component="h2" style={{ fontSize: "1.5rem" }}>
                        Please Enter the Shopify Shop URl and Shopify Access
                        Token
                      </FormLabel>

                      <Grid container spacing={3} p={2}>
                        <Grid item sm={12}>
                          {settings.isProcessed ? (
                            settings.isValid ? (
                              <Alert severity="success">
                                Url and access token is valid
                              </Alert>
                            ) : (
                              <Alert severity="error">
                                Invalid Shopify url or Invalid Access Token
                              </Alert>
                            )
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid item sm={12}>
                          <TextField
                            id="shopUrl"
                            name="shopUrl"
                            label="Shopify Shop URL"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.shopUrl}
                          />
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="shopUrl"
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <TextField
                            id="shopAccessToken"
                            name="shopAccessToken"
                            label="Shop Access Token"
                            fullWidth
                            variant="standard"
                            type={"password"}
                            autoComplete="new-password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.shopAccessToken}
                          />
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="shopAccessToken"
                          />
                        </Grid>
                        <Grid item sm={12}>
                          <Button
                            variant="contained"
                            type="submit"
                            startIcon={
                              verifyMutationResult.isLoading ? (
                                <CircularProgress
                                  size="1.2rem"
                                  color="inherit"
                                />
                              ) : (
                                ""
                              )
                            }
                            disabled={
                              verifyMutationResult.isLoading || settings.isValid
                            }
                          >
                            Verify
                          </Button>
                        </Grid>
                      </Grid>
                    </FormControl>
                  </Form>
                </>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ShopifySettings;
